(function() {
  'use strict';

  var drawerEl = document.querySelector('cart-drawer');
  if (!drawerEl) return;

  var FREE_SHIPPING_THRESHOLD = 15000; /* cents = $150 — free shipping to the lower 48 */
  var _confettiFired = false; /* Track across re-renders */

  /* ═══ AVADA Workaround: Patch open/close ═══
     cart-drawer.aio.min.js (deferred) defines CartDrawer as a custom element.
     When it runs, the element gets "upgraded" — the constructor fires and
     setHeaderCartIconAccessibility() binds click handlers.
     The upgrade replaces the element's prototype, wiping any instance overrides.
     Solution: wait for the custom element to be defined, THEN override. */

  function patchDrawer() {
    drawerEl.open = function(trigger) {
      if (trigger && typeof this.setActiveElement === 'function') this.setActiveElement(trigger);
      /* Cancel ALL AVADA animations that force visibility:hidden */
      try { this.getAnimations().forEach(function(a) { a.cancel(); }); } catch(e) {}
      this.classList.add('animate', 'active');
      this.style.visibility = 'visible';
      document.body.classList.add('overflow-hidden');
      /* Focus trap */
      var focusTarget = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : this.querySelector('.tss-drawer-panel');
      var inner = this.querySelector('.tss-drawer-close');
      if (focusTarget && typeof trapFocus === 'function') {
        trapFocus(focusTarget, inner);
      }
      /* Load upsells */
      loadUpsellProducts();
    };

    drawerEl.close = function() {
      this.classList.remove('active');
      this.style.visibility = '';
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }
    };

    /* Patch renderContents for product-form.js compatibility.
       Instead of parsing Dawn's section response (which conflicts with AVADA),
       we fetch fresh section HTML ourselves — same approach as ssrOpenCartDrawer. */
    drawerEl.renderContents = function(/* parsedState ignored */) {
      window.ssrOpenCartDrawer();
    };

    drawerEl.getSectionsToRender = function() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' }
      ];
    };

    drawerEl.getSectionInnerHTML = function(html, selector) {
      selector = selector || '.shopify-section';
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    };

    drawerEl.setActiveElement = function(el) { this.activeElement = el; };
  }

  /* Patch immediately */
  patchDrawer();
  /* Re-patch after custom element upgrade */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function() {
      setTimeout(patchDrawer, 0);
    });
  }

  /* ═══ Global cart interceptor — SIMPLE approach ═══
     Don't touch fetch at all. Just intercept navigation to /cart
     and jQuery ajax completion. Let builders do their thing. */

  /* Catch jQuery $.ajax add-to-cart completions (ssrOpenCartDrawer skips drawer in TSSApp UA). */
  function _tssBindJquery() {
    if (!window.jQuery) return;
    jQuery(document).ajaxComplete(function(event, xhr, settings) {
      if (settings.url && settings.url.indexOf('/cart/add') > -1 && xhr.status === 200) {
        setTimeout(function() { window.ssrOpenCartDrawer(); }, 300);
      }
    });
  }
  _tssBindJquery();
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', _tssBindJquery); } else { _tssBindJquery(); }

  /* ═══ Click-outside-to-close ═══
     The overlay element has an inline onclick="…close()", but it's been
     unreliable in production (AJAX re-renders + AVADA's prototype upgrades
     can break the binding). Belt-and-suspenders: a document-level handler
     that closes the drawer when a click lands on the visible page area
     outside the panel.

     Strategy: default-close on outside clicks, with explicit exclusions for
     anything we know is "part of the cart UX":
       • Inside `.tss-drawer-panel` — the cart itself
       • On the cart icon — would re-open immediately, looks broken
       • Inside ANY layered popup that's part of the cart/bundle flow:
         - .tss-variant-popup-overlay  (cart variant picker)
         - .tss-upsell-quickview-overlay  (PDP bundle builder quick-view)
         - .tss-atc-popup-overlay  (ATC popup)
         - [role="dialog"]  (generic catch-all)
     If a NEW popup is introduced later, add its overlay class here. Tommy
     reported a regression when only the variant popup was excluded but the
     new bundle quick-view wasn't — keep the list current as new popups land. */
  document.addEventListener('click', function(e) {
    if (!drawerEl.classList.contains('active')) return;
    /* Don't intercept clicks on the cart icon or /cart links — would
       re-open the drawer a tick later. */
    if (e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]')) return;
    /* Inside the panel itself → keep open. */
    var panel = drawerEl.querySelector('.tss-drawer-panel, .drawer__inner-empty');
    if (panel && panel.contains(e.target)) return;
    /* Inside any layered popup → keep open. */
    if (e.target.closest('.tss-variant-popup-overlay, .tss-upsell-quickview-overlay, .tss-atc-popup-overlay, [role="dialog"]')) return;
    /* Anywhere else (visible page behind the cart, the dim drawer overlay,
       app banners, etc.) → close. preventDefault stops the underlying click
       from accidentally triggering navigation. */
    e.preventDefault();
    e.stopPropagation();
    drawerEl.close();
  });

  /* Catch ALL clicks on links to /cart — open drawer instead.
     Excludes the in-PDP kit/bundle CTAs (`#ssr-link-to-car-kit`,
     `#ssr-byk-spraycan`, the build-bundle CTA). Those buttons open their own
     paint-kit / sample-builder / bundle UIs and must NOT be hijacked into
     opening the cart drawer — even if their href happens to end in `/cart`. */
  document.addEventListener('click', function(e) {
    /* Bail on PDP kit/bundle CTAs — they have their own click handlers. */
    if (e.target.closest('#ssr-link-to-car-kit, #ssr-byk-spraycan, [data-tss-build-bundle-cta-button], .SSR-build-your-kit-start, #add-to-bundle')) {
      return;
    }
    var link = e.target.closest('a[href="/cart"], a[href$="/cart"], a[href*="/cart?"]');
    if (link) {
      e.preventDefault();
      e.stopPropagation();
      window.ssrOpenCartDrawer();
      return false;
    }
    var bubble = e.target.closest('#cart-icon-bubble');
    if (bubble) {
      e.preventDefault();
      e.stopPropagation();
      drawerEl.open(bubble);
      return false;
    }
  }, true);

  /* Catch form submissions to /cart */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    var action = form.action || '';
    if (action.indexOf('/cart') > -1 && action.indexOf('/cart/add') === -1 && !form.closest('cart-drawer')) {
      e.preventDefault();
      window.ssrOpenCartDrawer();
    }
  }, true);

  /* Catch location.assign and location.replace to /cart */
  try {
    var _origAssign = window.location.assign.bind(window.location);
    window.location.assign = function(url) {
      if (typeof url === 'string' && (url === '/cart' || url.endsWith('/cart'))) {
        window.ssrOpenCartDrawer(); return;
      }
      return _origAssign(url);
    };
    var _origReplace = window.location.replace.bind(window.location);
    window.location.replace = function(url) {
      if (typeof url === 'string' && (url === '/cart' || url.endsWith('/cart'))) {
        window.ssrOpenCartDrawer(); return;
      }
      return _origReplace(url);
    };
  } catch(e) {}

  /* ═══ Cart icon click (failsafe) ═══ */
  document.addEventListener('click', function(e) {
    var cartIcon = e.target.closest('#cart-icon-bubble a, #cart-icon-bubble');
    if (!cartIcon) return;
    e.preventDefault();
    drawerEl.open(cartIcon);
  });

  /* Helper — read the line item's `key` off the .tss-cart-item wrapper.
     We pass `key` (the stable `<variantId>:<propsHash>` line item id) to
     /cart/change.js instead of `line` (1-indexed position). Position is
     unstable: any concurrent cart mutation between drawer-render and
     button-click shifts indexes, and the click then targets the wrong
     line OR a non-existent one (Shopify 422 → "Could not update cart").
     `key` is immutable for the life of the line item. */
  function lineKeyFor(el) {
    var wrap = el && el.closest && el.closest('.tss-cart-item');
    return wrap ? wrap.dataset.lineKey : null;
  }

  /* ═══ Quantity change (+/- buttons) ═══ */
  drawerEl.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (!qtyBtn) return;

    var key = lineKeyFor(qtyBtn);
    var line = parseInt(qtyBtn.dataset.line);
    var delta = parseInt(qtyBtn.dataset.qtyChange);
    var qtyInput = qtyBtn.closest('.tss-cart-item__qty').querySelector('[data-qty-input]');
    var currentQty = parseInt(qtyInput.value) || 0;
    var newQty = Math.max(0, currentQty + delta);
    qtyInput.value = newQty;
    updateCartLine(key || line, newQty, qtyBtn.closest('.tss-cart-item'));
  });

  /* ═══ Quantity input (typed value) ═══ */
  var qtyInputTimer;
  drawerEl.addEventListener('input', function(e) {
    var qtyInput = e.target.closest('[data-qty-input]');
    if (!qtyInput) return;
    clearTimeout(qtyInputTimer);
    qtyInputTimer = setTimeout(function() {
      var key = lineKeyFor(qtyInput);
      var line = parseInt(qtyInput.dataset.line);
      var newQty = parseInt(qtyInput.value) || 0;
      if (newQty < 0) newQty = 0;
      qtyInput.value = newQty;
      updateCartLine(key || line, newQty, qtyInput.closest('.tss-cart-item'));
    }, 600);
  });

  /* ═══ Remove item (trash icon) ═══ */
  drawerEl.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('[data-remove-line]');
    if (!removeBtn) return;
    var key = lineKeyFor(removeBtn);
    var line = parseInt(removeBtn.dataset.removeLine);
    updateCartLine(key || line, 0, removeBtn.closest('.tss-cart-item'));
  });

  function updateCartLine(lineOrKey, qty, itemEl) {
    /* lineOrKey: line item key string ("<variantId>:<hash>") preferred,
       falls back to numeric 1-indexed line position for older renders that
       haven't been re-fetched since the data-line-key change shipped. */
    /* Helper to ALWAYS clear the per-line loading spinner. Without this,
       any failure in the fetch chain (network blip, Shopify 422, /cart
       lock contention from a concurrent request) leaves the loader
       active forever and the user can never click trash again. */
    function clearLoader() {
      if (!itemEl) return;
      var loader = itemEl.querySelector('.tss-cart-item__loading');
      if (loader) loader.classList.remove('active');
    }

    if (itemEl) {
      var loader = itemEl.querySelector('.tss-cart-item__loading');
      if (loader) loader.classList.add('active');
    }

    /* Tell other cart-mutating scripts (return-label guard, etc.) to back off
       while a user-initiated write is in flight. They listen on cart:updated
       and would otherwise race us — Shopify's cart lock then 422s one of the
       two writes. Flag stays true through the drawer re-fetch so the guard
       doesn't try to "correct" a transient mid-refresh state. */
    window.__tssCartWriteInFlight = true;

    /* For DELETE (qty=0) we use /cart/update.js with an updates map keyed by
       line key. It's more forgiving than /cart/change.js — accepts the same
       line-key addressing, handles concurrent modifications without 422ing,
       and is the endpoint Shopify themselves recommend for bulk/safe updates.
       For quantity changes we keep /cart/change.js (better fit for delta-style
       single-line edits). Falls back to /cart/change.js if the key path can't
       be used. */
    var isDelete = (qty === 0);
    var useUpdate = isDelete && (typeof lineOrKey === 'string');
    var endpoint = useUpdate ? '/cart/update.js' : '/cart/change.js';
    var body = useUpdate
      ? { updates: (function () { var u = {}; u[lineOrKey] = 0; return u; })() }
      : (typeof lineOrKey === 'string')
        ? { id: lineOrKey, quantity: qty }
        : { line: lineOrKey, quantity: qty };

    console.log('[cart-drawer] →', endpoint, body);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) {
      /* Reject explicitly on non-OK status so the .catch fires instead of
         the chain continuing to render with bad data. */
      if (!r.ok) {
        return r.text().then(function(text) {
          throw new Error(endpoint + ' failed: HTTP ' + r.status + ' — ' + text);
        });
      }
      return r.json();
    })
    .then(function(result) {
      console.log('[cart-drawer] ✓', endpoint, 'items_now=', (result && result.item_count != null) ? result.item_count : '?');
      return result;
    })
    .then(function() {
      /* Re-fetch the drawer section to update everything */
      return fetch('/cart?section_id=cart-drawer');
    })
    .then(function(r) {
      if (!r.ok) throw new Error('cart drawer section fetch failed: HTTP ' + r.status);
      return r.text();
    })
    .then(function(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var source = parsed.querySelector('#CartDrawer');
      var target = document.querySelector('#CartDrawer');
      if (source && target) target.innerHTML = source.innerHTML;
      /* Update cart icon */
      fetch('/cart?section_id=cart-icon-bubble')
        .then(function(r) { return r.text(); })
        .then(function(bHtml) {
          var bp = new DOMParser().parseFromString(bHtml, 'text/html');
          var bt = document.getElementById('cart-icon-bubble');
          var bs = bp.querySelector('.shopify-section');
          if (bt && bs) bt.innerHTML = bs.innerHTML;
        })
        .catch(function(e) { console.warn('[cart-drawer] icon bubble update failed (non-fatal)', e); });
      /* Restore upsells */
      try { restoreUpsellFromCache(); } catch (e) { console.warn('[cart-drawer] restoreUpsellFromCache failed', e); }
      try { updateShippingBar(); } catch (e) { console.warn('[cart-drawer] updateShippingBar failed', e); }
      /* Re-bind overlay */
      var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', function() { drawerEl.close(); });
      /* If the cart is now empty, mark the drawer + notify any other on-page
         widgets via cart:refresh. The drawer was already re-rendered to its
         empty-state markup by the /cart?section_id=cart-drawer fetch above
         and the cart icon bubble updates independently — no full page reload
         needed (and a reload would close the drawer + discard scroll/preview
         state, which surprised users removing items). */
      fetch('/cart.json').then(function(r) { return r.json(); }).then(function(cart) {
        if (cart.item_count === 0) {
          drawerEl.classList.add('is-empty');
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'cart-drawer', emptied: true } })); } catch (_) {}
        }
      }).catch(function(e) { console.warn('[cart-drawer] empty check failed (non-fatal)', e); });
    })
    .catch(function(err) {
      /* Top-level failure — /cart/change.js OR the drawer re-render bombed.
         Most "failures" in production are actually false alarms: the
         return-label guard (or another script) races our write, Shopify's
         cart lock rejects one of the two simultaneous mutations with 422,
         and the cart still ends up in the state the user wanted. So before
         showing a scary "Could not update cart" notice, verify intent
         against the actual server-side cart. Only show the error when
         reality doesn't match what the user asked for. */
      console.error('[cart-drawer] updateCartLine failed', { lineOrKey: lineOrKey, qty: qty, err: err });

      function showErrorNotice() {
        try {
          if (window.tssToast) {
            window.tssToast('Could not update cart. Please try again.', 'error');
            return;
          }
          var top = drawerEl.querySelector('.tss-drawer-top');
          if (top) {
            var notice = document.createElement('div');
            notice.style.cssText = 'background:#fee;color:#c00;padding:8px 12px;font-size:12px;text-align:center;';
            notice.textContent = 'Could not update cart. Please try again.';
            top.parentNode.insertBefore(notice, top.nextSibling);
            setTimeout(function() { if (notice.parentNode) notice.parentNode.removeChild(notice); }, 4000);
          }
        } catch (_) {}
      }

      function refreshDrawerSilently() {
        return fetch('/cart?section_id=cart-drawer')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var source = parsed.querySelector('#CartDrawer');
            var target = document.querySelector('#CartDrawer');
            if (source && target) target.innerHTML = source.innerHTML;
            try { restoreUpsellFromCache(); } catch (_) {}
            try { updateShippingBar(); } catch (_) {}
          })
          .catch(function() {});
      }

      /* Returned so the outer .then(success, failure) waits for our recovery
         work before clearing the in-flight flag. Otherwise the guard could
         fire mid-refresh and re-introduce the race we're trying to dodge. */
      return fetch('/cart.json', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var items = cart.items || [];
          var matchesIntent = false;
          if (typeof lineOrKey === 'string') {
            var item = items.find(function(i) { return i.key === lineOrKey; });
            matchesIntent = (qty === 0) ? !item : (!!item && item.quantity === qty);
          } else if (typeof lineOrKey === 'number' && lineOrKey > 0) {
            var positional = items[lineOrKey - 1];
            matchesIntent = (qty === 0) ? !positional : (!!positional && positional.quantity === qty);
          }
          if (matchesIntent) {
            /* False alarm — cart is already where the user wanted it. Refresh
               the drawer silently so the UI matches and skip the error. */
            return refreshDrawerSilently();
          }
          /* Real failure — refresh drawer to known state AND show the error. */
          showErrorNotice();
          return refreshDrawerSilently();
        })
        .catch(function() {
          /* If even /cart.json fails, treat as a real failure. */
          showErrorNotice();
        });
    })
    .then(function() {
      /* Functional .finally — always clears the loader + drops the in-flight
         flag once everything (including recovery refresh on the error path)
         has settled. (Avoids Promise.prototype.finally for older Safari.) */
      clearLoader();
      window.__tssCartWriteInFlight = false;
    }, function() {
      clearLoader();
      window.__tssCartWriteInFlight = false;
    });
  }

  /* ═══ Shipping bar + installments update ═══ */
  function updateShippingBar() {
    fetch('/cart.json')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        /* Shipping bar */
        var bar = drawerEl.querySelector('.tss-drawer-top');
        var msg = drawerEl.querySelector('.tss-shipping-msg');
        if (bar) {
          var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
          var pct = Math.min(100, Math.round(cart.total_price / FREE_SHIPPING_THRESHOLD * 100));
          var fill = bar.querySelector('.tss-shipping-progress__fill');
          if (fill) {
            fill.style.width = pct + '%';
            if (remaining <= 0) {
              fill.classList.add('tss-shipping-progress__fill--full');
            } else {
              fill.classList.remove('tss-shipping-progress__fill--full');
            }
          }
          if (msg) {
            if (remaining <= 0) {
              msg.innerHTML = '🎉 You\'ve earned <strong>FREE</strong> Lower-48 Shipping!';
              if (!_confettiFired) {
                _confettiFired = true;
                window.tssLaunchConfetti(document.getElementById('tss-confetti-container'));
              }
            } else {
              _confettiFired = false;
              msg.innerHTML = 'Free Lower-48 Shipping is only <strong>$' + (remaining / 100).toFixed(2) + '</strong> away!';
            }
          }
        }
        /* Installments — update amounts dynamically */
        var spInstallment = drawerEl.querySelector('[data-sp-installment]');
        var spMonthly = drawerEl.querySelector('[data-sp-monthly]');
        if (spInstallment) {
          spInstallment.textContent = '$' + (cart.total_price / 400).toFixed(2) + ' ' + cart.currency;
        }
        if (spMonthly) {
          spMonthly.textContent = '$' + (cart.total_price / 2400).toFixed(2) + '/mo';
        }
      });
  }

  /* ═══ Discount code ═══ */
  drawerEl.addEventListener('click', function(e) {
    if (e.target.closest('[data-discount-apply]')) applyDiscount();
  });
  drawerEl.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      applyDiscount();
    }
  });

  function applyDiscount() {
    var input = drawerEl.querySelector('[data-discount-input]');
    var btn = drawerEl.querySelector('[data-discount-apply]');
    var msg = drawerEl.querySelector('[data-discount-msg]');
    if (!input || !btn) return;
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow' })
      .then(function() { return fetch('/cart.json'); })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var applied = false;
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          cart.cart_level_discount_applications.forEach(function(d) {
            if (d.title && d.title.toLowerCase() === code.toLowerCase()) applied = true;
          });
        }
        if (!applied && cart.items) {
          cart.items.forEach(function(item) {
            if (item.discount_allocations) {
              item.discount_allocations.forEach(function(da) {
                if (da.discount_application && da.discount_application.title &&
                    da.discount_application.title.toLowerCase() === code.toLowerCase()) applied = true;
              });
            }
          });
        }
        if (!applied && cart.total_discount > 0) applied = true;
        if (applied) {
          if (msg) { msg.textContent = 'Discount applied!'; msg.className = 'tss-discount-msg tss-discount-msg--success'; }
          setTimeout(function() { window.location.reload(); }, 600);
        } else {
          if (msg) { msg.textContent = 'Invalid discount code.'; msg.className = 'tss-discount-msg tss-discount-msg--error'; }
          fetch('/discount/clear', { method: 'GET', redirect: 'follow' }).catch(function(){});
          btn.textContent = 'Apply'; btn.disabled = false;
        }
      })
      .catch(function() {
        if (msg) { msg.textContent = 'Could not apply code. Try at checkout.'; msg.className = 'tss-discount-msg tss-discount-msg--error'; }
        btn.textContent = 'Apply'; btn.disabled = false;
      });
  }

  /* ═══ Free PDF add (delegation) ═══ */
  drawerEl.addEventListener('click', function(e) {
    var pdfBtn = e.target.closest('[data-free-pdf-add]');
    if (!pdfBtn || pdfBtn.disabled) return;
    e.preventDefault();
    var variantId = pdfBtn.dataset.variantId;
    var originalHTML = pdfBtn.innerHTML;
    pdfBtn.disabled = true;
    pdfBtn.innerHTML = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      pdfBtn.innerHTML = '✓ Added';
      if (typeof window.ssrOpenCartDrawer === 'function') {
        window.ssrOpenCartDrawer();
      } else {
        fetch('/cart?section_id=cart-drawer').then(function(r){return r.text();}).then(function(html){
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var source = parsed.querySelector('#CartDrawer');
          var target = document.querySelector('#CartDrawer');
          if (source && target) target.innerHTML = source.innerHTML;
        });
      }
      /* The drawer was just innerHTML-replaced (either branch above), which
         wipes out the upsell card grid that the engine had rendered into
         #tss-upsell-products. Re-paint from the existing cache so the
         "Recommended Add-Ons" rail isn't blank, then dispatch cart:refresh
         so the engine + return-label guard can react to the new cart state. */
      setTimeout(function () {
        try { restoreUpsellFromCache(); } catch (_) {}
        try { updateShippingBar(); } catch (_) {}
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'free-pdf-add' } })); } catch (_) {}
      }, 100);
    })
    .catch(function(err) {
      console.error('Free PDF add error:', err);
      pdfBtn.disabled = false;
      pdfBtn.innerHTML = originalHTML;
    });
  });

  /* ═══ Checkout button processing state ═══ */
  drawerEl.addEventListener('click', function(e) {
    var checkout = e.target.closest('#CartDrawer-Checkout');
    if (!checkout) return;
    checkout.classList.add('is-processing');
    checkout.innerHTML = '<svg style="width:18px;height:18px;animation:tssSpin 0.8s linear infinite" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Processing...';
    setTimeout(function() {
      if (document.body.contains(checkout)) {
        checkout.classList.remove('is-processing');
        checkout.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Secure Checkout';
      }
    }, 5000);
  });

  /* ═══ Upsell system — TSS in-theme engine (replaces Rebuy) ═══
     Fetches Shopify native /recommendations/products.json via window.TSSRecs
     (aggregated across cart items with category+ID filtering). Keeps the
     existing DOM structure (.tss-upsell-card etc.) so the drawer CSS and
     click handlers below keep working without changes. */
  var upsellLoadInFlight = false;
  var upsellProductMap = {};
  var upsellDebounceTimer = null;
  var cachedUpsellProducts = []; /* Normalized Shopify product objects */

  function loadUpsellProducts() {
    clearTimeout(upsellDebounceTimer);
    upsellDebounceTimer = setTimeout(_doLoadUpsell, 200);
  }

  function _doLoadUpsell() {
    /* If cached + drawer still has cards, just re-render (filter current cart) */
    if (cachedUpsellProducts.length) {
      renderUpsellCards();
      return;
    }
    if (upsellLoadInFlight) return;
    upsellLoadInFlight = true;

    /* Wait for TSSRecs to be defined (it's deferred) */
    function run() {
      if (!window.TSSRecs || typeof window.TSSRecs.getForCart !== 'function') {
        setTimeout(run, 100);
        return;
      }
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          /* Slot count = 12. The engine pads with related/storefront fallbacks
             so we always show a full row (Tommy: "at least 12 at all times,
             optimized depending on what's in the cart"). */
          return window.TSSRecs.getForCart(cart.items || [], 12);
        })
        .then(function(products) {
          upsellLoadInFlight = false;
          cachedUpsellProducts = products || [];
          cachedUpsellProducts.forEach(function(p) { upsellProductMap[p.id] = p; });
          renderUpsellCards();
        })
        .catch(function(err) {
          upsellLoadInFlight = false;
          console.warn('TSS upsell error:', err);
        });
    }
    run();
  }

  /* Render upsell cards, filtering out products already in cart.
     Keeps the same DOM markup as the previous Rebuy-fed renderer so existing
     CSS + click delegation below (.tss-upsell-card__img, [data-upsell-add],
     [data-upsell-options], showVariantPopup) continues to work. */
  function renderUpsellCards() {
    /* Track product handles currently in cart (handle-based match — DOM-reliable) */
    var cartProductHandles = {};
    document.querySelectorAll('.tss-cart-item__title a').forEach(function(a) {
      var match = (a.href || '').match(/\/products\/([^?#]+)/);
      if (match) cartProductHandles[match[1]] = true;
    });

    /* Defense-in-depth blocklist filter — engine should already filter, but
       belt-and-suspenders ensures a stale cache or upstream bug never leaks
       a blocked product into the rendered DOM. Sourced from
       window.TSS_BLOCKED_PRODUCT_IDS (emitted by cart-drawer.liquid). */
    var blockedIds = {};
    if (Array.isArray(window.TSS_BLOCKED_PRODUCT_IDS)) {
      window.TSS_BLOCKED_PRODUCT_IDS.forEach(function (id) { if (id != null) blockedIds[id] = true; });
    }

    upsellProductMap = {};
    var html = '';
    cachedUpsellProducts.forEach(function(product) {
      if (!product) return;
      if (blockedIds[product.id]) return;
      var handle = product.handle || '';
      if (handle && cartProductHandles[handle]) return;

      upsellProductMap[product.id] = product;
      var variants = product.variants || [];
      var variant = variants[0] || {};
      var hasMultiple = variants.length > 1;

      /* Image: Shopify recs API returns array of URL strings */
      var imgSrc = '';
      if (product.featured_image) imgSrc = product.featured_image;
      else if (product.image && product.image.src) imgSrc = product.image.src;
      else if (product.images && product.images.length) {
        var firstImg = product.images[0];
        imgSrc = (typeof firstImg === 'string') ? firstImg : (firstImg && firstImg.src ? firstImg.src : '');
      }
      if (imgSrc) imgSrc = imgSrc.replace(/\.([a-zA-Z]+)(\?|$)/, '_200x200.$1$2');

      /* Prices arrive as integer cents (normalized at the fetcher boundary in
         tss-recommendations.js → priceToCents). Just divide by 100 to display. */
      var priceCents = priceCentsOf(variant.price != null ? variant.price : product.price);
      var compareCents = priceCentsOf(variant.compare_at_price != null ? variant.compare_at_price : product.compareAtPrice != null ? product.compareAtPrice : product.compare_at_price);

      var fromLabel = hasMultiple ? '<span class="tss-upsell-card__from">From</span> ' : '';
      var comparePrice = (compareCents > priceCents && priceCents > 0)
        ? '<span class="tss-upsell-card__compare">$' + (compareCents / 100).toFixed(2) + '</span> '
        : '';
      var priceHTML = '<span class="tss-upsell-card__sale">$' + (priceCents / 100).toFixed(2) + '</span>';

      var addAttr = hasMultiple
        ? 'data-upsell-options="' + product.id + '"'
        : 'data-upsell-add="' + (variant.id || '') + '"';

      var safeTitle = (product.title || '').replace(/"/g, '&quot;');

      html += '<div class="tss-upsell-card">' +
        '<div class="tss-upsell-card__img">' +
          '<img src="' + imgSrc + '" alt="' + safeTitle + '" loading="lazy">' +
          '<button class="tss-upsell-card__add" ' + addAttr + ' aria-label="Add">+</button>' +
        '</div>' +
        '<div class="tss-upsell-card__name">' + (product.title || '') + '</div>' +
        '<div class="tss-upsell-card__prices">' + fromLabel + comparePrice + priceHTML + '</div>' +
      '</div>';
    });

    ['tss-upsell-products', 'tss-upsell-products-empty'].forEach(function(id) {
      var c = document.getElementById(id);
      if (c) c.innerHTML = html;
    });
  }

  /* Coerce any incoming price value to integer cents.
     Source of truth: window.TSSRecs.priceToCents — defined in tss-recommendations.js
     and shared with the on-page widget + ATC popup so all renderers behave the
     same. We fall back to a local copy in case TSSRecs hasn't loaded yet (defer
     load order can race the first render). */
  function priceCentsOf(val) {
    if (window.TSSRecs && typeof window.TSSRecs.priceToCents === 'function') {
      return window.TSSRecs.priceToCents(val);
    }
    if (val == null || val === '') return 0;
    if (typeof val === 'string') {
      if (val.indexOf('.') !== -1) {
        var f = parseFloat(val);
        return isFinite(f) ? Math.round(f * 100) : 0;
      }
      var n = parseInt(val, 10);
      return isFinite(n) ? n : 0;
    }
    if (typeof val === 'number') {
      return isFinite(val) ? Math.round(val) : 0;
    }
    return 0;
  }

  function restoreUpsellFromCache() {
    if (cachedUpsellProducts.length) renderUpsellCards();
  }

  /* ═══ Upsell click handlers (delegation) ═══ */
  drawerEl.addEventListener('click', function(e) {
    /* Clicking the image area acts like clicking the + button */
    var imgArea = e.target.closest('.tss-upsell-card__img');
    var addBtn = e.target.closest('[data-upsell-add]');
    var optionsBtn = e.target.closest('[data-upsell-options]');

    /* If clicked on img area (not the + button directly), find the action from the + button */
    if (imgArea && !addBtn && !optionsBtn) {
      var btn = imgArea.querySelector('[data-upsell-add], [data-upsell-options]');
      if (btn) {
        if (btn.dataset.upsellOptions) { optionsBtn = btn; }
        else { addBtn = btn; }
      }
    }

    if (addBtn && !optionsBtn) {
      var card = addBtn.closest('.tss-upsell-card');
      var variantId = addBtn.dataset.upsellAdd;
      addBtn.innerHTML = '<svg style="width:14px;height:14px;animation:tssSpin 0.6s linear infinite" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4"/></svg>';
      /* Tier 1 attribution: stamp this line item so the BizSync orders/paid
         webhook can attribute it to the cart_drawer surface. Best-effort rule
         name from window.TSS_CART_RULES (emitted by cart-drawer.liquid).
         addOrBumpUpsellItems (from tss-recommendations.js) bumps existing
         lines instead of stamping duplicates — keeps the cart visually
         clean when the customer already had this variant from another
         surface. */
      var __tssCartRules = (window.TSS_CART_RULES && window.TSS_CART_RULES.length) ? window.TSS_CART_RULES : null;
      /* BizSync upsell attribution — compact single-property form.
         cart_drawer is not product-specific so source_product_id and
         source_url are blank. */
      var __tssCdRule = ((__tssCartRules && __tssCartRules[0] && __tssCartRules[0].ruleName) || '').replace(/\|/g, '/');
      var __tssCartDrawerProps = {
        '_tss_u': 'cart_drawer|tss-cart-drawer-upsell|' + __tssCdRule + '||'
      };
      var __tssAddOrBump = (window.TSSRecs && window.TSSRecs.addOrBumpUpsellItems)
        ? window.TSSRecs.addOrBumpUpsellItems([{ id: parseInt(variantId), quantity: 1 }], __tssCartDrawerProps)
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1, properties: __tssCartDrawerProps }] })
          });
      __tssAddOrBump
      .then(function() {
        addBtn.innerHTML = '✓';
        addBtn.style.background = '#28a745';
        /* Remove the card with a fade */
        if (card) {
          card.style.transition = 'opacity 0.3s, transform 0.3s';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.8)';
          setTimeout(function() { card.remove(); }, 300);
        }
        /* Refresh drawer — upsells will re-render automatically filtering out cart items */
        window.ssrOpenCartDrawer();
        /* Tag with source so the ATC popup's listener knows to skip re-opening
           — popup must only fire for PDP main-form ATCs. */
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'cart-drawer-upsell' } }));
        } catch (e) {}
      })
      .catch(function() { addBtn.innerHTML = '+'; });
      return;
    }

    if (optionsBtn) {
      var productId = optionsBtn.dataset.upsellOptions;
      var product = upsellProductMap[productId];
      if (!product) return;
      showVariantPopup(product);
      return;
    }
  });

  /* ═══ Variant popup ═══ */
  var _popupProductId = null;

  function showVariantPopup(product) {
    var overlay = document.getElementById('tss-variant-popup-overlay');
    var titleEl = document.getElementById('tss-variant-popup-title');
    var imgEl = document.getElementById('tss-variant-popup-img');
    var optionsEl = document.getElementById('tss-variant-popup-options');
    var atcBtn = document.getElementById('tss-variant-popup-atc');
    if (!overlay || !optionsEl) return;

    _popupProductId = product.id;
    titleEl.textContent = product.title;
    var imgSrc = product.image ? product.image.src : (product.images && product.images[0] ? product.images[0].src : '');
    if (imgSrc) {
      imgEl.src = imgSrc.replace(/\.([^.]+)$/, '_300x300.$1');
      imgEl.alt = product.title;
      imgEl.style.display = '';
    } else {
      imgEl.style.display = 'none';
    }

    optionsEl.innerHTML = product.variants.map(function(v) {
      /* Prices arrive in integer cents (normalized at the fetcher boundary in
         tss-recommendations.js → priceToCents). Format = (cents / 100).toFixed(2). */
      var vCents = priceCentsOf(v.price);
      var cCents = priceCentsOf(v.compare_at_price);
      var vDollars = (vCents / 100).toFixed(2);
      var cDollars = (cCents / 100).toFixed(2);
      var vPriceHTML = (cCents > vCents)
        ? '<span style="text-decoration:line-through;color:#999;margin-right:4px">$' + cDollars + '</span> <strong>$' + vDollars + '</strong>'
        : '<strong>$' + vDollars + '</strong>';
      return '<div class="tss-variant-popup__option" data-variant-id="' + v.id + '" data-variant-price-cents="' + vCents + '">' +
        '<div class="tss-variant-popup__option-info">' +
          '<span class="tss-variant-popup__option-name">' + v.title + '</span>' +
          '<div class="tss-variant-popup__option-price">' + vPriceHTML + '</div>' +
        '</div>' +
        '<div class="tss-variant-popup__qty">' +
          '<button type="button" data-vqty="-1">−</button>' +
          '<span data-vqty-val>0</span>' +
          '<button type="button" data-vqty="1">+</button>' +
        '</div>' +
      '</div>';
    }).join('');

    /* Reset ATC button */
    atcBtn.disabled = true;
    atcBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> Add to Cart';

    overlay.classList.add('active');
    overlay.onclick = function(e) {
      if (e.target === overlay) overlay.classList.remove('active');
    };
  }

  /* Variant popup qty +/- buttons */
  document.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('[data-vqty]');
    if (!qtyBtn) return;
    var option = qtyBtn.closest('.tss-variant-popup__option');
    var valSpan = option.querySelector('[data-vqty-val]');
    var current = parseInt(valSpan.textContent) || 0;
    var delta = parseInt(qtyBtn.dataset.vqty);
    var newVal = Math.max(0, current + delta);
    valSpan.textContent = newVal;
    option.classList.toggle('has-qty', newVal > 0);

    /* Update the ATC button — count total items & total price */
    updatePopupAtcButton();
  });

  function updatePopupAtcButton() {
    var atcBtn = document.getElementById('tss-variant-popup-atc');
    var options = document.querySelectorAll('#tss-variant-popup-options .tss-variant-popup__option');
    var totalItems = 0;
    var totalCents = 0;
    options.forEach(function(opt) {
      var qty = parseInt(opt.querySelector('[data-vqty-val]').textContent) || 0;
      /* dataset.variantPriceCents holds integer cents; sum and divide once at end. */
      var cents = parseInt(opt.dataset.variantPriceCents, 10) || 0;
      totalItems += qty;
      totalCents += qty * cents;
    });
    if (totalItems > 0) {
      atcBtn.disabled = false;
      atcBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> Add ' + totalItems + ' item' + (totalItems > 1 ? 's' : '') + ' — $' + (totalCents / 100).toFixed(2);
    } else {
      atcBtn.disabled = true;
      atcBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> Add to Cart';
    }
  }

  /* Variant popup ATC button — adds all selected variants at once */
  document.addEventListener('click', function(e) {
    var atcBtn = e.target.closest('#tss-variant-popup-atc');
    if (!atcBtn || atcBtn.disabled) return;

    var overlay = document.getElementById('tss-variant-popup-overlay');
    var options = document.querySelectorAll('#tss-variant-popup-options .tss-variant-popup__option');
    var items = [];
    options.forEach(function(opt) {
      var qty = parseInt(opt.querySelector('[data-vqty-val]').textContent) || 0;
      if (qty > 0) {
        items.push({ id: parseInt(opt.dataset.variantId), quantity: qty });
      }
    });
    if (!items.length) return;

    atcBtn.disabled = true;
    atcBtn.innerHTML = '<svg style="width:16px;height:16px;animation:tssSpin 0.8s linear infinite" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Adding...';

    /* Tier 1 attribution: same source / widget id as the +-button click
       handler above. Routed through addOrBumpUpsellItems so any variant
       already in the cart gets its quantity bumped instead of duplicated
       as a new _tss_*-stamped line item. */
    var __tssVariantPopupRules = (window.TSS_CART_RULES && window.TSS_CART_RULES.length) ? window.TSS_CART_RULES : null;
    var __tssVariantPopupRule = ((__tssVariantPopupRules && __tssVariantPopupRules[0] && __tssVariantPopupRules[0].ruleName) || '').replace(/\|/g, '/');
    /* BizSync upsell attribution — compact form. Variant popup is a sub-
       flow of cart drawer; webhook normalizer collapses widget_id 'tss-cart-
       drawer-variant-popup' → 'tss-cart-drawer-upsell' on persist. */
    var __tssVariantPopupProps = {
      '_tss_u': 'cart_drawer|tss-cart-drawer-variant-popup|' + __tssVariantPopupRule + '||'
    };

    var __tssVariantAddOrBump = (window.TSSRecs && window.TSSRecs.addOrBumpUpsellItems)
      ? window.TSSRecs.addOrBumpUpsellItems(items, __tssVariantPopupProps)
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items.map(function (it) {
            return { id: it.id, quantity: it.quantity, properties: __tssVariantPopupProps };
          }) })
        });
    __tssVariantAddOrBump
    .then(function() {
      atcBtn.innerHTML = '✓ Added!';
      atcBtn.style.background = '#28a745';

      /* Remove the upsell card for this product */
      if (_popupProductId) {
        var card = drawerEl.querySelector('[data-upsell-options="' + _popupProductId + '"]');
        if (card) card = card.closest('.tss-upsell-card');
        if (card) {
          card.style.transition = 'opacity 0.3s, transform 0.3s';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.8)';
          setTimeout(function() { card.remove(); }, 300);
        }
      }

      setTimeout(function() {
        if (overlay) overlay.classList.remove('active');
        atcBtn.style.background = '';
        window.ssrOpenCartDrawer();
        /* Tag with source so the ATC popup's listener skips re-opening. */
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'cart-drawer-upsell' } }));
        } catch (e) {}
      }, 600);
    })
    .catch(function() {
      atcBtn.disabled = false;
      atcBtn.innerHTML = 'Add to Cart';
    });
  });

  /* ═══ MutationObserver: restore state after ssrOpenCartDrawer re-renders ═══ */
  var observerTarget = document.getElementById('CartDrawer');
  if (observerTarget) {
    var mutDebounce = null;
    var observer = new MutationObserver(function() {
      clearTimeout(mutDebounce);
      mutDebounce = setTimeout(function() {
        /* Restore upsells */
        restoreUpsellFromCache();
        /* Ensure drawer stays visible if active */
        if (drawerEl.classList.contains('active')) {
          try { drawerEl.getAnimations().forEach(function(a) { a.cancel(); }); } catch(e) {}
          drawerEl.style.visibility = 'visible';
          document.body.classList.add('overflow-hidden');
        }
        /* Re-bind overlay */
        var newOverlay = drawerEl.querySelector('#CartDrawer-Overlay');
        if (newOverlay) newOverlay.addEventListener('click', function() { drawerEl.close(); });
      }, 50);
    });
    observer.observe(observerTarget, { childList: true });
  }

  /* ═══ Expose upsell API globally ═══ */
  /* ═══ Confetti burst (matches sample builder) — exposed globally ═══ */
  window.tssLaunchConfetti = function(container) {
    if (!container) return;
    container.innerHTML = '';
    var colors = ['#25bfbd','#1a9e9c','#ff6b6b','#ffd93d','#6bcb77','#4d96ff','#ff922b','#cc5de8'];
    for (var i = 0; i < 40; i++) {
      var piece = document.createElement('span');
      piece.className = 'tss-confetti-piece';
      var color = colors[Math.floor(Math.random() * colors.length)];
      var cx = (Math.random() - 0.5) * 300;
      var cy = (Math.random() - 1) * 200 - 20;
      piece.style.background = color;
      piece.style.left = (Math.random() * 100) + '%';
      piece.style.top = '50%';
      piece.style.setProperty('--cx', cx + 'px');
      piece.style.setProperty('--cy', cy + 'px');
      piece.style.animationDelay = (Math.random() * 0.3) + 's';
      container.appendChild(piece);
    }
    setTimeout(function() { container.innerHTML = ''; }, 1600);
  }

  /* Fire confetti on first drawer open if free shipping already earned */
  if (drawerEl && drawerEl.dataset && drawerEl.dataset.freeShippingEarned === 'true') {
    _confettiFired = true; /* Mark as already earned so updateShippingBar doesn't re-fire */
    var _confettiOnOpen = setInterval(function() {
      if (drawerEl.classList.contains('active')) {
        clearInterval(_confettiOnOpen);
        setTimeout(function() {
          window.tssLaunchConfetti(document.getElementById('tss-confetti-container'));
        }, 300);
      }
    }, 200);
    /* Stop checking after 30s to avoid leaking */
    setTimeout(function() { clearInterval(_confettiOnOpen); }, 30000);
  }

  window.tssUpsell = {
    load: loadUpsellProducts,
    refresh: function() { cachedUpsellProducts = []; loadUpsellProducts(); }
  };

  /* Listen for cart:refresh events (fired by TSSRecs.acceptUpsell) */
  document.addEventListener('cart:refresh', function() {
    cachedUpsellProducts = [];
    loadUpsellProducts();
  });

  /* ═══ Prefetch upsells on page load so they're instant when drawer opens ═══ */
  _doLoadUpsell();

  /* ═══ Fix dynamic checkout button layout ═══
     Shopify's accelerated checkout renders async. Once it loads,
     force the buttons into a row and limit to 2 on mobile. */

})();
